import { PATH_WEB_HOOK, PATH_FRONT } from "../App/constants";

export const getPaymentFormat = (total, intId, interId) => {
  const totalStr = total.replace(".", "");
  const payment = {
    importe: parseInt(totalStr),
    fecha_vto: getExpiration(),
    descripcion: "Descripción del pago N",
    referencia_externa: interId,
    url_redirect: `${PATH_FRONT}${intId}`,
    webhook: PATH_WEB_HOOK,
  };
  return payment;
};

const getExpiration = () => {
  var today = new Date();
  today.setDate(today.getDate() + 4);
  return today.toISOString().slice(0, 10);
};
